import { useState } from "react";
import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../../store/action/loadingAction";
import { setError } from "../../../store/action/errorAction";
import apiConfig from "../../../config/apiConfig";
import { showSuccessToasts } from "../../../services/helpers/Helper";

const VideoLive = (props) => {
   const { page, hideLoading, showLoading, setError } = props;
   const [title, setTitle] = useState('');
   const [desc, setDesc] = useState('');
   const [preview, setPreview] = useState();
   const [comments, setComments] = useState();
   const [res, setRes] = useState();
   const hanldeStart = async () => {
      const formData = new FormData();
      if (!title) {
         setError("Can not leave the title blank");
         return;
      }
      if (!desc) {
         setError("Can not leave the description blank");
         return;
      }
      if (title.length > 160) {
         setError("Title must not exceed 160 characters");
         return;
      }
      if (desc.length > 160) {
         setError("Description must not exceed 160 characters");
         return;
      }
      formData.append('title', title);
      formData.append('description', desc);
      formData.append('fb_page_id', page.social_id);
      showLoading();
      await apiConfig.post('/SocialApi/upload/create-video-live', formData).then((response) => {
         showSuccessToasts("Success");
         setRes(response.data);
      }).catch(() => { });
      hideLoading();
   }

   const handleStop = async () => {
      const formData = new FormData();
      formData.append('live_video_id', preview.id);
      formData.append('fb_page_id', page.social_id);
      showLoading();
      await apiConfig.post('/SocialApi/upload/stop-video-live', formData).then(() => {
         showSuccessToasts("Success");
      }).catch(() => { });
      hideLoading();
   }

   const handlePreview = () => {
      apiConfig.get('/SocialApi/upload/page-current-live' + '?fb_page_id=' + page.social_id).then((response) => {
         showSuccessToasts("Success");
         setPreview(response.data);
      }).catch(() => { });
   }

   const listComment = async () => {
      if (preview?.video?.id) {
         showLoading();
         apiConfig.get('/SocialApi/page/facebook/list-comments-post' + '?fb_page_id=' + page.social_id + '&post_id=' + preview?.video?.id).then((response) => {
            showSuccessToasts("Success");
            setComments(response.data);
         }).catch(() => { });
         hideLoading();
      }
   }

   return (
      <div id="bot-scene-container">
         <div style={{ display: 'flex' }}>
            <div style={{ padding: 20, width: '50%', margin: '0 auto' }}>
               <div style={{
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 20,
                  lineHeight: '29px',
                  textAlign: 'center'
               }}>Live Video On Page</div>
               <div className="close-sales-filter">
                  <div style={{ marginBottom: 30 }}>
                     <label htmlFor="">Title </label>
                     <div className="hrs-filter-search-wrapper">
                        <input className="hrs-filter-input-search" placeholder="Title " value={title} onChange={(e) => setTitle(e.target.value)} />
                     </div>
                  </div>
                  <div style={{ marginBottom: 30 }}>
                     <label htmlFor="">Description</label>
                     <div className="hrs-filter-search-wrapper">
                        <input className="hrs-filter-input-search" placeholder="Description" value={desc} onChange={(e) => setDesc(e.target.value)} />
                     </div>
                  </div>
                  <div style={{ marginBottom: 30, color: 'red' }}>

                     {res ? <><span>Response: </span> <br /> {res}</> : ""}
                  </div>
                  <div style={{
                     margin: '0 0 0 auto',
                     display: 'flex',
                     justifyContent: 'flex-end'
                  }}>
                     <button className="app-btn app-btn-primary app-btn-size-small" style={{
                        marginRight: 20
                     }} onClick={hanldeStart}>
                        Start
                     </button>
                     <button className="app-btn app-btn-primary app-btn-size-small" onClick={handleStop}>
                        Stop
                     </button>
                  </div>
               </div>
            </div>
            <div style={{ padding: 20, width: '50%', margin: '0 auto' }}>
               {preview?.embed_html ?
                  <div dangerouslySetInnerHTML={{
                     __html: preview.embed_html
                  }}></div>
                  :
                  <div style={{
                     margin: '0 0 0 auto',
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     height: '100%'
                  }}>
                     <button className="app-btn app-btn-primary app-btn-size-small" onClick={handlePreview}>
                        Preview
                     </button>
                  </div>
               }
            </div>
         </div>
         {preview?.video?.id &&
            <div style={{ padding: 20, width: '50%' }}>
               <button className="app-btn app-btn-primary app-btn-size-small" onClick={listComment}>
                  Load Comment
               </button>
               <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 10 }}>
                  {comments?.map((comment, index) => {
                     if (index > 20) {
                        return;
                     }
                     return (
                        <div key={index} style={{ padding: 10, textAlign: 'right', fontSize: 16, background: '#2325270a' }}>{comment.message}</div>
                     )
                  })}
               </div>
            </div>
         }
      </div>
   )
}


const mapStateToProps = (state) => {
   const { page } = state;
   return {
      page
   }
}

export default connect(mapStateToProps, {
   showLoading,
   hideLoading,
   setError
})(VideoLive);